import { PipeLink } from '@creativegs/pipe-toolkit/components'
import { oSeriesPages } from 'types/oSeriesPages'
import { useSurveyTranslations } from '@creativegs/pipe-toolkit/utils/translation'

const Test2: React.FC = () => {
  const { t } = useSurveyTranslations('2-test')

  return (
    <div className="pt-32 px-7 max-w-md mx-auto">
      <h1 className="text-center text-xl text-tundora font-bold mb-6 font-helvetica">
        {t('title')}
      </h1>
      <div className="max-w-sm mx-auto">
        <PipeLink href={oSeriesPages.test3}>
          <button className="btn-test mb-3">{t('button.answer1')}</button>
        </PipeLink>
        <PipeLink href={oSeriesPages.test3}>
          <button className="btn-test mb-3">{t('button.answer2')}</button>
        </PipeLink>
      </div>
    </div>
  )
}

export default Test2
